import { render, staticRenderFns } from "./PacotesCicloMensal.vue?vue&type=template&id=1b741744&"
import script from "./PacotesCicloMensal.vue?vue&type=script&lang=js&"
export * from "./PacotesCicloMensal.vue?vue&type=script&lang=js&"
import style0 from "./PacotesCicloMensal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports